module.exports = __webpack_public_path__ + "img/extended.08ec7945.png";